import { Flight } from "../../../models/flight.model";
import { amount } from "../../form/controls";

/** The actual N1, N2 and IMP of each engine of the flight. */
export function engineControls(flight: Flight) {
    const data = flight.engineData;
    return {
        engine1ActualN1: amount(data?.engine1ActualN1 ?? null),
        engine1ActualN2: amount(data?.engine1ActualN2 ?? null),
        engine1ActualImp: amount(data?.engine1ActualImp ?? null),
        engine2ActualN1: amount(data?.engine2ActualN1 ?? null),
        engine2ActualN2: amount(data?.engine2ActualN2 ?? null),
        engine2ActualImp: amount(data?.engine2ActualImp ?? null),
    };
}
